import FormSection from '@/components/Forms/FormSection';
import { Box } from '@palmetto/palmetto-components';
import { Link } from 'react-router-dom';

import {
  WaterHeaterInstallPackageFileCategory,
  InstallationPackagePhotoCategory,
  ProgramType,
  RequirementFlagSettingsType,
} from 'types';

import { PhotosList } from '../Documents/PhotosList';

export const SystemPhotos = ({
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
}: {
  showCheckboxes: boolean;
  checkboxCategories: WaterHeaterInstallPackageFileCategory[];
  isPackageEditable?: boolean;
}) => {
  return (
    <>
      <FormSection
        title="New System Photos"
        description={
          <>
            <Box>Upload photos to all applicable categories.</Box>
            <Box>
              Reference <Link to={''}>Install Photo Requirements documentation</Link> for specifics on submission
              requirements.
            </Box>
          </>
        }
      >
        <PhotosList
          title="Equipment Data Plate"
          description="Photo must show manufacturer's data plate with serial number, model number, and capacity rating clearly visible"
          category={InstallationPackagePhotoCategory.equipmentDataPlate}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.equipmentDataPlateWaterHeater}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.waterHeater}
          isPackageEditable={isPackageEditable}
        />
        <PhotosList
          title="Wide Installation View"
          description="Photo must show the complete water heater unit and surrounding installation area, including connections and clearances"
          category={InstallationPackagePhotoCategory.wideInstallationView}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.wideInstallationViewWaterHeater}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.waterHeater}
          isPackageEditable={isPackageEditable}
        />
        <PhotosList
          title="Temperature & Pressure (T&P) Relief Valve"
          description="Photo must show valve installation, discharge pipe, and connection point"
          category={InstallationPackagePhotoCategory.tpReliefValve}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.tpReliefValveWaterHeater}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.waterHeater}
          isPackageEditable={isPackageEditable}
        />
        <PhotosList
          title="Drain Pan & Drain Line"
          description="Photo must show drain pan properly installed beneath unit with drain line routing visible"
          category={InstallationPackagePhotoCategory.drainPanDrainLine}
          baseCategory="Installation Photo Documentation"
          flagType={RequirementFlagSettingsType.drainPanDrainLineWaterHeater}
          showCheckboxes={showCheckboxes}
          checkboxCategories={checkboxCategories}
          programType={ProgramType.waterHeater}
          isPackageEditable={isPackageEditable}
        />
      </FormSection>
    </>
  );
};
